import { Country, MaterialCreationProcess } from 'api';
import { MaterialComponentValueSchema } from 'features';
import { type InferType, yup } from 'form';
import { translate } from 'i18n';

export const MaterialProductSchema = yup
  .object({
    buyer_material_component_values: yup
      .array()
      .of(MaterialComponentValueSchema)
      .required()
      .min(
        1,
        translate('backlog.materialProducts.validation.atLeastOneBuyerMaterialComponentIsRequired', {
          namespace: 'features',
        })
      ),
    country: yup.string().oneOf(Object.values(Country)).required(),
    creation_process: yup.string().oneOf(Object.values(MaterialCreationProcess)).optional(),
    has_caps_and_labels: yup.boolean().optional(),
    is_food_grade: yup.boolean().optional(),
    material_colour_id: yup.number().optional(),
    material_grade_id: yup.number().required(),
    material_id: yup.number().optional(),
    material_origin_id: yup.number().optional(),
    material_spec_id: yup.number().required(),
    seller_material_component_values: yup
      .array()
      .of(MaterialComponentValueSchema)
      .required()
      .min(
        1,
        translate('backlog.materialProducts.validation.atLeastOneSellerMaterialComponentIsRequired', {
          namespace: 'features',
        })
      ),
  })
  .test(
    'buyer-seller-material-component-values-length',
    translate('backlog.materialProducts.validation.buyerAndSellerMaterialComponentCountsMustMatch', {
      namespace: 'features',
    }),
    function (value) {
      const isSameLength =
        value.buyer_material_component_values?.length === value.seller_material_component_values?.length;
      if (!isSameLength) {
        return this.createError({
          message: translate('backlog.materialProducts.validation.buyerAndSellerMaterialComponentCountsMustMatch', {
            namespace: 'features',
          }),
          path: 'seller_material_component_values',
        });
      }
      return true;
    }
  );

export type MaterialProductFormValues = InferType<typeof MaterialProductSchema>;
